module.exports = __webpack_public_path__ + "static/maiaflashwhite-45ff8b9b3a47dc48b80d70652b165021.png";